import { light } from '@fortawesome/fontawesome-svg-core/import.macro';
import { Modal, ModalBody, ModalProps, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import SuccessImage from '../../../assets/success.svg';
import Button from '../../../components/Button/Button';
import ModalHeader from '../../../components/ModalHeader';
import useMobile from '../../../hooks/useMobileHook';
import { TRANSACTION_HISTORY_ROUTE } from '../../../routes/types';

export type customSuccessDialogProps = ModalProps &
  React.PropsWithChildren<{
    showSuccessDialog: boolean;
    handleCloseSuccessDialog: () => void;
  }>;

const SuccessDialog = ({
  showSuccessDialog,
  handleCloseSuccessDialog,
  children,
}: customSuccessDialogProps) => {
  const navigate = useNavigate();
  const isMobile = useMobile();

  return (
    <Modal
      show={showSuccessDialog}
      onHide={handleCloseSuccessDialog}
      dialogClassName="modal-lg custom-success-modal"
      fullscreen={isMobile}
    >
      <ModalHeader className="justify-content-center" closeButton></ModalHeader>
      <ModalBody className="pt-0">
        <Row className="m-0 pb-12 text-center">
          <h4>Success!</h4>
        </Row>
        <Row className="m-0 pb-12 justify-content-center">
          <img className="img-container" src={SuccessImage} alt="success-img" />
        </Row>
        <Row className="m-0">{children}</Row>
      </ModalBody>
      <Modal.Footer>
        <Button
          variant="primary-outline"
          onMouseDown={handleCloseSuccessDialog}
          className="mt-7 mt-lg-0 order-1"
        >
          Close
        </Button>
        <Button
          variant="primary"
          onMouseDown={() => {}}
          rightIcon={light('list-timeline')}
          className="order-2 mt-7 mt-lg-0"
          onClick={() => navigate(TRANSACTION_HISTORY_ROUTE)}
        >
          Transaction History
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default SuccessDialog;
